import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Star } from 'lucide-react';
import './css/ModernAuditionCard.css';
import './new-home/LiveOpportunities.css';

const ModernAuditionCard = ({ audition }) => {
  if (!audition) return null;

  // Map keys from your new JSON response
  const id = audition.id || audition.jogetRoleId;
  // const jogetRoleId = audition.jogetRoleId || audition.id;
  const urlSlug = audition.urlSlug || '';
  const projectName = audition.projectName || 'Untitled Project';
  const roleTitle = audition.roleTitle || 'Untitled Role';
  const roleCategory = audition.roleCategory || 'Talent Required';
  const endDate = audition.projectEndDate;
  
  let expiryText = '';

if (endDate) {

  const today = new Date();

  const expiryDate =
    new Date(endDate);

  const diffTime =
    expiryDate - today;

  const diffDays =
    Math.ceil(
      diffTime /
      (1000 * 60 * 60 * 24)
    );

  if (diffDays === 0) {
    expiryText = 'Expires Today';
  }

  else if (diffDays === 1) {
    expiryText = 'Expires Tomorrow';
  }

  else if (diffDays > 1 && diffDays <= 7) {
    expiryText =
      `Expires in ${diffDays} Days`;
  }
}

  // Use the full URL provided by the backend (includes the SVG placeholder)
  const defaultAvatar = `https://ui-avatars.com/api/?name=${encodeURIComponent(projectName)}&background=050506&color=fff&size=20`;
  const displayImage = audition.projectImageUrl || defaultAvatar;
  const roleCost = audition.roleCost;
  const expirySoon = audition.expirySoon;
  // const finalAmount = audition.finalAmount || 0;
  const finalAmount = Number(
  audition?.roleCost?.totalAmount ||
  audition.finalAmount ||
  audition.final_amount ||
  0
).toFixed(2);
  console.log("CARD DATA =>", audition);
console.log("ROLE COST =>", roleCost);

  const formatType = (text) => {
    if (!text || text === 'N/A') return 'Audition';
    return text.replace(/([A-Z])/g, ' $1').trim();
  };

  const auditionTypes = audition.auditionType && audition.auditionType !== 'N/A'
    ? audition.auditionType.split(';').map((t) => formatType(t))
    : ['Audition'];
  const ageGroup = audition.ageGroup || '18-30 yrs'; // Fallback
  const location = audition.location || 'Online';
  const payText = finalAmount > 0 ? `₹${finalAmount}` : 'Unpaid';

  return (
    <Link to={`/audition/${id}/${urlSlug}`} className="audition-card-link" style={{ textDecoration: 'none' }}>
      <div className="live-opp-card-wrapper native-card" style={{ padding: 0 }}>
        <div className="live-opp-card">
          <div className="live-opp-image-box">
            <img src={displayImage} alt={projectName} className="live-opp-img" loading="lazy" />
            <div className="live-opp-gradient"></div>
            
            <div className="live-opp-top-badges">
              <div className="live-opp-strip-left">
                {auditionTypes.map((type, idx) => (
                  <span key={idx} className="live-opp-type-badge">{type}</span>
                ))}
              </div>
              <div className="live-opp-strip-right">
                <span className="live-opp-cat-badge">{roleCategory}</span>
              </div>
            </div>
            
            <div className="live-opp-overlay-content">
              <span className="opp-card-category">{roleCategory}</span>
              <h3 className="opp-card-title">{projectName}</h3>
              <span className="opp-card-role">{roleTitle}</span>
              <span className="opp-card-details">{ageGroup} | {location}</span>
            </div>
          </div>
          <div className="live-opp-footer">
            <div className="opp-card-pay">{payText}</div>
            <div className="opp-card-status text-red">{expiryText || (endDate ? `Ends: ${new Date(endDate).toLocaleDateString('en-GB')}` : '')}</div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ModernAuditionCard;